import React from "react";

function OnBoardDetails({ empDetails, clickReset, clickEdit, clickDelete }) {
  const isDeletable = () => {
    const assignedDate = new Date(empDetails?.assignedDate);
    const today = new Date();
    console.log(today);
    return assignedDate >= today;
  };
  console.log(isDeletable());
  return (
    <div className="card mt-3 p-3 w-100 shadow-sm" style={{ fontSize: "12px" }}>
      <h6 className="fw-bold" style={{ color: "#d38740" }}>
        Onboarding Details
      </h6>
      <p className="mb-1">
        <strong>Name:</strong> {empDetails?.name}
      </p>
      <p className="mb-1">
        <strong>Description:</strong> {empDetails?.description}
      </p>
      <p className="mb-1">
        <strong>Assigned:</strong> {empDetails?.recruiter?.employee?.firstName}{" "}
        {empDetails?.recruiter?.employee?.middleName}{" "}
        {empDetails?.recruiter?.employee?.lastName}
      </p>
      <p className="mb-1">
        <strong>Date:</strong>{" "}
        {new Date(empDetails?.assignedDate).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })}
      </p>

      {/* Buttons */}

      <div className="d-flex justify-content-between mt-3">
        {/* <button
          className="btn bg-danger text-white flex-grow-1"
          // style={{ backgroundColor: "#3f7cc0" }}
          onClick={() => clickDelete()}
        >
          Delete
        </button> */}
        <button
          className="btn text-white flex-grow-1 me-2"
          disabled={!isDeletable()}
          onClick={() => clickEdit()}
          style={{ backgroundColor: "#d38740" }}
        >
          Edit
        </button>
      </div>
    </div>
  );
}

export default OnBoardDetails;
